import moment from 'moment';
import { get } from 'lodash';
import { INVERTED_METRIC_SWITCH_MAP, getMetricDisplayName } from '@utils/metrics';

export const buildAnnotationObj = ({ metricKey, appliedFilter, sliceInterval, createdBy }) => {
  try {
    return {
      annotationId: null,
      metricKey,
      startTimestamp: moment.utc(sliceInterval[0]).format(),
      endTimestamp: moment.utc(sliceInterval[1]).format(),
      filterRule: appliedFilter.rule,
      filterName: appliedFilter.name,
      annotationType: 'metric',
      isPublic: false,
      createdBy,
      comments: [],
    };
  } catch (err) {
    return {};
  }
};

export const formatNewAnnotation = (payload) => {
  const { activeAnnotation, comment } = payload;
  return {
    annotation: activeAnnotation,
    comment: { description: comment },
  };
};

export const formatAnnotationComment = (payload) => {
  const { activeAnnotation, comment } = payload;
  return {
    description: comment,
    annotationId: activeAnnotation.annotationId,
  };
};

export const formatUpdateAnnotation = (payload) => {
  const { annotationId, metricKey, ...rest } = payload;
  return {
    payload: { ...rest },
    annotationId,
    metricKey,
  };
};

export const getTitle = ({ metricKey, filterName, endTimestamp }) => {
  const endTime = moment(endTimestamp).format('lll');
  const displayName = getMetricDisplayName({ metricKey });
  return `Metric: ${displayName} | Filter: ${filterName} | ${endTime}`;
};

// read format
export const formatAnnotationRow = (annotation) => {
  let annotationComment = (annotation.comments.length && annotation.comments[0].description) || '';
  if (annotationComment.length > 30) {
    annotationComment = annotationComment.substring(0, 25) + '...';
  }

  const formattedAnnotation = {
    annotation,
    // markline point
    xAxis: annotation.endTimestamp,
    // used for tooltip
    info: {
      title: getTitle({ ...annotation }),
      comment: `${annotationComment}`,
    },
  };

  return formattedAnnotation;
};

export const parseAnnotations = (data = {}, validMetrics = []) => {
  const formattedData: any = {};
  const rawList = get(data, 'data.annotations', []);

  validMetrics.forEach((metric) => {
    formattedData[metric] = [];
    const invertedMetric = INVERTED_METRIC_SWITCH_MAP[metric];
    if (invertedMetric) {
      formattedData[invertedMetric] = [];
    }
  });

  rawList.forEach((annotation: any) => {
    switch (annotation.annotationType) {
      case 'all': {
        Object.keys(formattedData).forEach((metricKey) => {
          formattedData[metricKey].push(formatAnnotationRow(annotation));
        });
        break;
      }
      case 'metric': {
        const metric = INVERTED_METRIC_SWITCH_MAP[annotation.metricKey] || annotation.metricKey;
        if (metric in formattedData) {
          formattedData[metric].push(formatAnnotationRow(annotation));
        }
        break;
      }
      default:
        break;
    }
  });
  return formattedData;
};

export const annotationExportHeader: any = [
  {
    key: 'xAxis',
    title: 'Timestamp',
  },
  {
    key: 'metric',
    title: 'Metric',
  },
  {
    key: 'sourceMetric',
    title: 'Source Metric',
  },
  {
    key: 'filterName',
    title: 'Filter',
  },
  {
    key: 'type',
    title: 'Type',
  },
  {
    key: 'comments',
    title: 'Comments',
    type: 'comment',
  },
];
